import { CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { TasklistComponent } from '../app/tasks/tasklist/tasklist.component';
import { TaskComponent } from '../app/tasks/task/task.component';
import { AddTaskComponent } from 'src/app/tasks/add-task/add-task.component';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { LoaderComponent } from './loader/loader.component';
import { LogListComponent } from '../app/logboek/log-list/log-list-component';
import { LogListItemComponent } from '../app/logboek/log-list-item/log-list-item.component';
import { HeaderComponent } from './header/header.component';
import { RouterModule } from '@angular/router';
import { PicturePickerComponent } from '../app/logboek/picture-picker/picture-picker.component';
import { PictureCardGridComponent } from '../app/logboek/picture-card-grid/picture-card-grid.component';
import { PictureCardComponent } from '../app/logboek/picture-card/picture-card.component';
import { LogShowDatePipe } from '../pipes/log-show-date.pipe';
import { HighlighterPipe } from '../app/highlighter.pipe';
import { MaintenanceperiodPipe } from '../app/maintenanceperiod.pipe';
import { TaskDetailsModalComponent } from '../app/task-details-modal/task-details-modal.component';
import { OverdueMaintenanceListComponent } from '../app/overdue-maintenance-list/overdue-maintenance-list.component';
import { FeatureFlagDirective } from '../app/feature-flag.directive';
import {
    AddMaintenanceTaskModalComponent
} from '../app/add-maintenance-task-modal/add-maintenance-task-modal.component';
import { ChangeLogModalComponent } from '../app/change-log-modal/change-log-modal.component';
import { NextPerformanceCardComponent } from '../app/next-performance-card/next-performance-card.component';
import { RehearsalUrlComponent } from './rehearsal-url/rehearsal-url.component';
import { UploadFieldComponent } from '../app/upload-field/upload-field.component';
import { TaskCounterCardComponent } from '../app/task-counter-card/task-counter-card.component';
import { TaskFormComponent } from '../app/tasks/task-form/task-form.component';
import { TasksDetailsPage } from '../app/tasks/task-details/task-details.page';
import {
    FullscreenFileImageModalComponent
} from '../app/tasks/fullscreen-file-image-modal/fullscreen-file-image-modal.component';
import { PinchZoomComponent } from '@meddv/ngx-pinch-zoom';
import { CaroPerformanceListComponent } from '../app/caro-performance-list/caro-performance-list.component';
import { ReadableDateTimePipe } from '../app/pipes/readable-date-time.pipe';
import {
    PlannerPerformanceRowComponent
} from '../app/planner/planner-performance-row/planner-performance-row.component';
import { PerformanceAanvangTijdPipe } from '../app/performance-aanvang-tijd.pipe';
import {
    PlannerPerformanceListComponent
} from '../app/planner/planner-performance-list/planner-performance-list.component';
import {
    DocumentDownloadButtonComponent
} from '../app/shared/document-download-button/document-download-button.component';
import {
    NoNetworkConnectionMessageComponent
} from '../app/shared/no-network-connection-message/no-network-connection-message.component';
import { PerformanceCrewListComponent } from '../app/shared/performance-crew-list/performance-crew-list.component';
import {
    ShowreportTechnicalItemsPreviewListComponent
} from '../app/shared/showreport-technical-items-preview-list/showreport-technical-items-preview-list.component';
import { LogButtonComponent } from '../app/dashboard/log-button/log-button.component';
import { ShowreportButtonComponent } from '../app/dashboard/showreport-button/showreport-button.component';
import {
    PerformanceDocumentDownloadButtonsListComponent
} from '../app/dashboard/performance-document-download-buttons-list/performance-document-download-buttons-list.component';
import { GetUserFullNameFromPerformanceWithRolePipe } from '../app/get-user-full-name-from-performance-with-role.pipe';
import { DatastatusPipe } from '../app/datastatus.pipe';
import {
    PerformanceDayListItemComponent
} from '../app/performance/performance-day-list-item/performance-day-list-item.component';
import { PerformanceRowComponent } from '../app/performances/performances/performance-row/performance-row.component';
import {
    PerformanceCrewFieldComponent
} from '../app/performances/performances/performance-crew-field/performance-crew-field.component';
import { CrewSelectDropdownComponent } from '../app/shared/crew-select-dropdown/crew-select-dropdown.component';
import {
    RehearsalDetailsListComponent
} from '../app/rehearsal/rehearsal-details-list/rehearsal-details-list.component';
import { RehearsalSummaryComponent } from '../app/rehearsal/rehearsal-summary/rehearsal-summary.component';
import {
    RehearsalDetailsModalComponent
} from '../app/rehearsal/rehearsal-details-modal/rehearsal-details-modal.component';
import {
    MaintenanceTaskChecklistModalComponent
} from '../app/shares/maintenance-task-checklist-modal/maintenance-task-checklist-modal.component';
import { RehearsalFormComponent } from '../app/rehearsal/rehearsal-form/rehearsal-form.component';
import { ShowAvatarComponent } from './show-avatar/show-avatar.component';
import { ShowFilterBarComponent } from './show-filter-bar/show-filter-bar.component';
import { MetadataFooterComponent } from '../app/shared/metadata-footer/metadata-footer.component';
import { ShowreportListItemComponent } from '../app/showreport/showreport-list-item/showreport-list-item.component';

@NgModule({
    declarations: [
        TasklistComponent,
        TaskComponent,
        AddTaskComponent,
        LoaderComponent,
        LogListComponent,
        LogListItemComponent,
        HeaderComponent,
        PicturePickerComponent,
        PictureCardGridComponent,
        PictureCardComponent,
        LogShowDatePipe,
        HighlighterPipe,
        MaintenanceperiodPipe,
        TaskDetailsModalComponent,
        OverdueMaintenanceListComponent,
        FeatureFlagDirective,
        AddMaintenanceTaskModalComponent,
        ChangeLogModalComponent,
        NextPerformanceCardComponent,
        UploadFieldComponent,
        TaskCounterCardComponent,
        TaskFormComponent,
        TasksDetailsPage,
        FullscreenFileImageModalComponent,
        CaroPerformanceListComponent,
        ReadableDateTimePipe,
        PlannerPerformanceRowComponent,
        PlannerPerformanceListComponent,
        DocumentDownloadButtonComponent,
        NoNetworkConnectionMessageComponent,
        PerformanceCrewListComponent,
        ShowreportTechnicalItemsPreviewListComponent,
        LogButtonComponent,
        ShowreportButtonComponent,
        PerformanceDocumentDownloadButtonsListComponent,
        PerformanceDayListItemComponent,
        PerformanceRowComponent,
        PerformanceCrewFieldComponent,
        CrewSelectDropdownComponent,
        RehearsalDetailsListComponent,
        RehearsalSummaryComponent,
        RehearsalDetailsModalComponent,
        MaintenanceTaskChecklistModalComponent,
        RehearsalFormComponent,
        MetadataFooterComponent,
        ShowreportListItemComponent
    ],
    imports: [RouterModule, CommonModule, IonicModule, FormsModule, PinchZoomComponent, PerformanceAanvangTijdPipe, GetUserFullNameFromPerformanceWithRolePipe, DatastatusPipe, ShowAvatarComponent, ShowFilterBarComponent, RehearsalUrlComponent, TranslateModule],
    exports: [
        TasklistComponent,
        TaskComponent,
        AddTaskComponent,
        LoaderComponent,
        LogListComponent,
        LogListItemComponent,
        HeaderComponent,
        PicturePickerComponent,
        LogShowDatePipe,
        HighlighterPipe,
        MaintenanceperiodPipe,
        TaskDetailsModalComponent,
        OverdueMaintenanceListComponent,
        FeatureFlagDirective,
        AddMaintenanceTaskModalComponent,
        ChangeLogModalComponent,
        NextPerformanceCardComponent,
        TaskCounterCardComponent,
        UploadFieldComponent,
        TaskFormComponent,
        TasksDetailsPage,
        FullscreenFileImageModalComponent,
        CaroPerformanceListComponent,
        ReadableDateTimePipe,
        PlannerPerformanceRowComponent,
        PlannerPerformanceListComponent,
        DocumentDownloadButtonComponent,
        NoNetworkConnectionMessageComponent,
        PerformanceCrewListComponent,
        ShowreportTechnicalItemsPreviewListComponent,
        PerformanceDocumentDownloadButtonsListComponent,
        ShowreportButtonComponent,
        LogButtonComponent,
        PerformanceDayListItemComponent,
        PerformanceRowComponent,
        PerformanceCrewFieldComponent,
        CrewSelectDropdownComponent,
        RehearsalDetailsListComponent,
        RehearsalSummaryComponent,
        RehearsalDetailsModalComponent,
        MaintenanceTaskChecklistModalComponent,
        RehearsalFormComponent,
        ShowAvatarComponent,
        ShowFilterBarComponent,
        MetadataFooterComponent,
        ShowreportListItemComponent,
        TranslateModule,
        PictureCardGridComponent,
        PictureCardComponent
    ],
    providers: [
        {provide: LOCALE_ID, useValue: 'nl-NL'}
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule {
}
